// TODO: Hardik - remove console statements
import { useEffect, useState } from 'react';

import {
  APPLE_PAY_BASE_CONFIG,
  APPLE_PAY_SCRIPT_URL,
  TAP_MERCHANT_ID,
  TAP_PAY_CURRENCY_CODE
} from '@/config/tapPayments';
import { isBrowser } from '@/lib/utils';
import mobileNumber from '@/lib/validations/mobile-number';
import { HOST_PORTAL_FQDN } from '@/services/connections.service';
import { getSanitizedTapToken } from '@/services/payment.service';

const { getPhoneNumberDetails } = mobileNumber;

const ApplePay = ({
  hostEmail,
  hostMobile,
  hostName,
  onClickPayAmount,
  setTapSanitizedToken,
  transactionAmount
}) => {
  const [isReady, setIsReady] = useState(false);

  const { countryCode, number } = getPhoneNumberDetails(hostMobile);

  useEffect(() => {
    let unmountFunction = null;
    setIsReady(false);

    const loadTapApplePay = () => {
      if (isBrowser() && window.TapApplepaySDK) {
        const { render } = window.TapApplepaySDK;

        if (unmountFunction) {
          unmountFunction();
        }

        const { unmount } = render(
          {
            ...APPLE_PAY_BASE_CONFIG,
            merchant: {
              domain: HOST_PORTAL_FQDN,
              id: TAP_MERCHANT_ID
            },
            transaction: {
              currency: TAP_PAY_CURRENCY_CODE,
              amount: transactionAmount
            },
            customer: {
              name: [
                {
                  locale: 'en',
                  first: hostName.split(' ')[0]
                }
              ],
              contact: {
                email: hostEmail,
                phone: {
                  number,
                  countryCode
                }
              }
            },
            onCancel: () => {
              console.debug('onCancel_applePay');
            },
            onError: (error) => {
              console.error('onError_applePay', error);
            },
            onReady: () => {
              console.debug('onReady_applePay');
              setIsReady(true);
            },
            onSuccess: async (data) => {
              console.debug('onSuccess_applePay', data);
              setTapSanitizedToken(getSanitizedTapToken({ token: data }));
              await onClickPayAmount();
            }
          },
          'apple-pay-button'
        );
        unmountFunction = unmount;
      }
    };

    if (isBrowser() && window.TapApplepaySDK) {
      loadTapApplePay();
    } else {
      const script = document.createElement('script');
      script.src = APPLE_PAY_SCRIPT_URL;
      script.onload = loadTapApplePay;
      document.body.appendChild(script);
    }

    return () => {
      if (unmountFunction) {
        unmountFunction();
      }
      setIsReady(false);
    };
  }, []);

  return (
    <div
      id='apple-pay-button'
      className={isReady ? '' : 'opacity-50 cursor-not-allowed'}
    ></div>
  );
};

export default ApplePay;
